import { z } from 'zod';

import { DocumentId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const PhysicallyMailDocumentSideEffectContext = BaseLoanIdSideEffect.extend({
  documentId: DocumentId,
  auditLogComment: z.string(),
});
export const PhysicallyMailDocumentSideEffect = PhysicallyMailDocumentSideEffectContext.extend({
  type: z.literal('physicallyMailDocument'),
});
export type PhysicallyMailDocumentSideEffect = z.infer<typeof PhysicallyMailDocumentSideEffect>;
